import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

export const Disclaimer = () => {
    return (
        <div className="sid-disclaimer sid-personal-info-disclaimer" >
            <FormattedHTMLMessage
                id="step.personalInfo.disclaimer"
                defaultMessage={
                    `You acknowledge, agree and accept that the information you enter
                    into this student offer form will be (a) used by SheerID for
                    verification purposes, (b) shared with PicsArt by SheerID, and (c)
                    used by PicsArt in accordance with and subject to its Terms of Use
                    and Privacy Policy.`} />
        </div>
    );
};
